import React from "react";
import { MobileFlightDetailsModal as FlightDetailsModal } from "halifax";
import { FareDetails, TripDetails } from "redmond";

import "./styles.scss";
import clsx from "clsx";
import { getSliceIndex } from "../FlightShopHeader/FlightSummaryPanel/constants";
import { getPlusDays, getReviewCardHeader } from "./constants";
import { getIsMixedClass } from "../FlightList/components/FlightDetails/component";
import { useIsTravelApp } from "@capone/common";

interface IMobileItineraryModalProps {
  isDeparture: boolean;
  tripDetails: TripDetails;
  fareDetails: FareDetails | undefined;
  openModal: boolean;
  onClose: () => void;
  buttonText?: string;
  onClick?: () => void;
}

export const MobileFlightDetailsModal = (props: IMobileItineraryModalProps) => {
  const { isDeparture, tripDetails, openModal, onClick, fareDetails } = props;

  if (!openModal) return null;

  const sliceIndex = tripDetails ? getSliceIndex(isDeparture, tripDetails) : 0;
  const tripSlice = tripDetails?.slices[sliceIndex];
  const [isMixedCabinClass, setIsMixedCabinClass] = React.useState(false);

  const { isTravelApp } = useIsTravelApp();

  React.useEffect(() => {
    if (fareDetails) {
      isDeparture
        ? setIsMixedCabinClass(getIsMixedClass(fareDetails.slices[0]))
        : setIsMixedCabinClass(getIsMixedClass(fareDetails.slices[1]));
    }
  }, [fareDetails]);

  const renderCardHeader = (header: string) => {
    const [fromHeader, dateHeader] = header.split(":");
    return (
      <>
        <span className="from">{fromHeader}</span>
        <span className="date">{dateHeader}</span>
      </>
    );
  };
  return (
    <FlightDetailsModal
      {...props}
      departure={isDeparture}
      title={renderCardHeader(
        getReviewCardHeader(
          props.isDeparture,
          tripSlice?.destinationCode,
          tripSlice?.departureTime,
          true
        )
      )}
      plusDays={getPlusDays(tripSlice)}
      isMixedCabinClass={isMixedCabinClass}
      className={clsx(
        "mobile-itinerary-details-modal-root",
        "b2b",
        "b2b-secondary"
      )}
      onClick={onClick}
      showCloseButton={!isTravelApp}
    />
  );
};
